import styled from 'styled-components';
import { breakpoints } from '../../../../../styles/theme';
import { StockModelCardDealerInfoStyled } from '../StockModelCardDealerInfoStyled';
import { rem } from 'polished';

export const StockModelCardDealerInfoStyledDS = styled(StockModelCardDealerInfoStyled)`
    .dealer-location {
        border: 1px solid ${({ theme }) => theme.colors.grey16};
        background: ${({ theme }) => theme.colors.white};
        border-radius: ${rem(8)};
        width: 80%;
        margin: 0 auto;
        &--icon {
            svg {
                height: ${rem('22px')};
                width: ${rem('14px')};
                margin: 0 ${rem('10px')} 0 ${rem('3px')};
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }
        &--info {
            color: ${({ theme }) => theme.colors.black};
            font-size: ${({ theme }) => theme.fontSizes.h6};
        }
        &--address {
            font-size: ${({ theme }) => theme.fontSizes.h6};
            margin-top: ${rem(2)};
        }
    }
`;
